export default "__VITE_ASSET__BwgSKhrM__"